import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subscription } from 'rxjs';

@Component({
    selector: 'pim-text-filter',
    templateUrl: './text-filter.component.html',
    styleUrls: ['./text-filter.component.sass'],
    standalone: false
})
export class TextFilterComponent implements OnDestroy {
	@Input()
	viewOnly: boolean = false;

	@Input()
	tooltipText: string = '';

	@Output()
	queryChanged: EventEmitter<string> = new EventEmitter<string>();

	searchForm!: UntypedFormGroup;

	private sub: Subscription = new Subscription();
	// To enable multiple text-filter-components on the same page
	id: number;

	constructor(private fb: UntypedFormBuilder) {
		this.id = Math.floor(Math.random() * 1000) + 1;
		this.initFormAndHandler();
	}

	ngOnDestroy(): void {
		this.sub.unsubscribe();
	}

	private initFormAndHandler(): void {
		this.searchForm = this.fb.group({
			searchQuery: ['']
		});
		this.sub.add(
			this.searchForm.get('searchQuery')?.valueChanges.pipe(
				debounceTime(300),
				distinctUntilChanged()
			).subscribe((value: string) => {
				this.queryChanged.emit(value);
			})
		);

	}
}
